import React from 'react';

import Flux from 'views/Flux';
import aboutRouter from './AboutRouter';
import automaticRouter from './AutomaticRouter';
import personalizedRouter from './PersonalizedRouter';
import uploadRouter from './UploadRouter';

const fluxRouter = {
  path: 'flux',
  children: [
    { path: '', element: <Flux /> },
    automaticRouter,
    personalizedRouter,
    uploadRouter,
    aboutRouter,
  ],
};

export default fluxRouter;
